import * as Ariakit from '@ariakit/react';
import { styled } from 'styled-components';

import { Text } from '../../Text/Text';
import { SelectHeader, SelectItemContent, SelectWrapper } from './CommonSelectComponents';
import { CommonSelectProps } from './types/CommonSelectProps';
import { ErrorMessage } from '../ErrorMessage';
import { SelectItemStyle, SelectListStyle, StyledSelectPopover } from './Select';

export const StandardSelect = ({
  value,
  setValue,
  options,
  label,
  disabled,
  errorMessage,
  errorVariant,
  hasError,
  onToggleFavorite,
  showFavorites,
  testId,
  hideLabel,
  hideDescription = false,
}: CommonSelectProps) => {
  const multiple = Array.isArray(value);

  const selectStore = Ariakit.useSelectStore({
    items: options,
    value,
    setValue,
  });

  return (
    <SelectWrapper style={{ gap: 10, alignContent: 'flex-end' }}>
      <Ariakit.SelectLabel store={selectStore} hidden={hideLabel}>
        <Text color="black70">{label} </Text>
      </Ariakit.SelectLabel>
      <SelectHeader
        options={options}
        label={label}
        selectStore={selectStore}
        disabled={disabled}
        hasError={hasError}
        testId={testId}
      />

      <StyledSelectPopover store={selectStore} sameWidth flip={false} fixed={true} unmountOnHide>
        <StyledSelectList store={selectStore}>
          {options.map(option => (
            <StyledSelectItem
              key={option.id}
              value={option.id}
              data-testid={`test-option-${option.id}`}
              disabled={option.isDisabled}
              store={selectStore}
            >
              <SelectItemContent
                option={option}
                multiple={multiple}
                showFavorites={showFavorites}
                hideDescription={hideDescription}
              />
            </StyledSelectItem>
          ))}
        </StyledSelectList>
      </StyledSelectPopover>
      {hasError && !disabled && (
        <ErrorMessage testId={`${testId}-error`} variant={errorVariant}>
          {errorMessage}
        </ErrorMessage>
      )}
    </SelectWrapper>
  );
};

const StyledSelectList = styled(Ariakit.SelectList)`
  ${SelectListStyle}
`;

const StyledSelectItem = styled(Ariakit.SelectItem)`
  ${SelectItemStyle}
  min-height: 50px;
`;
